const baseUrl = 'https://crdascz.siga.com.bo/api/';
//const baseUrl = 'http://localhost:64760/api/';
//const baseLite = "http://localhost/formulario_solicitud/"
// const baseLite = "http://crdascz.com/crdasczX/formulario_solicitud/"
const baseLocal = "http://localhost/formulario_solicitud/"
const baseProd = "http://crdascz.com/crdasczX/formulario_solicitud/"

//const baseCampeonato = process.env.NODE_ENV === 'production' ? "http://crdascz.com/campeonatoback/" : "http://localhost:8000/"

const baseCampeonato = 'http://crdascz.com/campeonatoback/'

const baseLite = process.env.NODE_ENV === 'production' ? baseProd : baseLocal

const api = {
  baseUrl,
  baseCampeonato,
  get(url){
    return fetch(`${baseUrl}${url}`, { method: "GET" }).then(response => response.json());
  },
  postLite(url, data){
    return fetch(`${baseLite}${url}`, {
      method: "POST",
      body: JSON.stringify(data)
    }).then(response => response.json());
  },
  getLite(url){
    return fetch(`${baseLite}${url}`, { method: "GET" }).then(response => response.json());
  },
  getCampeonato(url){
    return fetch(`${baseCampeonato}${url}`, { method: "GET" }).then(response => response.json());
  },
}

export default api;
